<template>
  <div>
  <v-row>
    <v-col lg="7"
           xs="12">
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left" style="max-width: 100px">Attendee Name</th>
            <th class="text-left">Location</th>
            <th class="text-left">Purchased Tickets</th>
          </tr>
          </thead>
          <tbody>
          <tr
              class="ma-4">
            <td class="text-left" >
              {{ state.member.meeting.previouslyRegistered.firstName }} {{ state.member.meeting.previouslyRegistered.lastName }}
            </td>
            <td class="text-left">
              {{ state.member.meeting.previouslyRegistered.city }}, {{ state.member.meeting.previouslyRegistered.state }}
            </td>

            <td class="text-left">
              <ul>
                <li v-for="(product, index) in state.member.meeting.previouslyRegistered.purchasedProducts"
                    :key="'product-'+index">
                  {{ product }}
                </li>
              </ul>
            </td>
          </tr>
          </tbody>

        </template>
      </v-simple-table>

    </v-col>

  </v-row>
  <v-row>
    <v-col>
      <h2>Click continue if the above information is correct and you would like to add more products or tickets to this registration.</h2>
      <br>
      <v-btn color="#488ba6" @click="continueUpdateRegistration" style="color:white">Continue</v-btn>

      <br><br>
      <p><em>If you are having issues with the system please email <a href="mailto:debug@fvs.org">debug@fvs.org</a> and we will assist you with your registration.</em></p>
    </v-col>
  </v-row>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  name: "LookupVerify",
  computed: {
    ...mapGetters({
      state: 'getState',
    }),
  },
  methods:{
    continueUpdateRegistration() {
      this.$store.commit("continueUpdateRegForm", "shop");
    }
  }
}
</script>

<style scoped>

</style>